import './Theme.Box.Badge.scss';
export default 'ThemeBoxBadge';
